module.exports = __webpack_public_path__ + "img/power_demo.0847e4c5.jpg";